import { AbstractControl } from '@angular/forms';
export class PasswordValidation {

   static MatchPassword(AC: AbstractControl) {
      let password = AC?.get('password')?.value;
      if(AC.get('ripeti_password')?.touched || AC.get('ripeti_password')?.dirty) {
         let verifyPassword = AC.get('ripeti_password')?.value;

         if(password != verifyPassword) {
            AC.get('ripeti_password')?.setErrors( {MatchPassword: true} )
         } else {
            return null
         }
      }
      return null
   }
}
